<template>
	<row-object-page name="list_edit" :oref="oref" v-model="list"></row-object-page>
</template>

<script setup lang="ts">
import {ref, computed, provide} from "vue";
import RowObjectPage from "@/pages/row-object/RowObjectPage.vue";
import {objectRef, RowObjectInit, RowObjectRef, RowObjectType, SrcType} from "@t/meta/SourceType.ts";
import {useNavigationStore} from "@/store/NavigationStore.ts";
import {TOOLS_GROUP_ID} from "@t/ui/Menu.ts";
import type {AppList} from "@t/list/List.ts";
import {connectEventBus, injectEnv} from "@fd/Environment.ts";
import {CREATE, EDIT, REPLACE_INIT_WITH_EDIT} from "@/pages/row-object/RowObjectEvents.ts";
import {useVirtualRoute} from "@/router/virtual/VirtualRouter.ts";

const ns = useNavigationStore();
const bus = connectEventBus("ListPage");
const env = injectEnv();
const list = ref<AppList>(null);
const route = useVirtualRoute();
const oref = objectRef(route, SrcType.LIST);

ns.listenForStackerUpdates(bus, oref, () => env.msg('menu.createList'),
	"/editList.do", () => list.value.title, () => list.value.id);

ns.defineMenu((mb) => {
	if (list.value?.canModify && list.value?.id) {
		mb.inGroup(TOOLS_GROUP_ID, (gb) => {
			gb.confirmDelete(gb.navItem("deleteList", "deleteList.do?id="+list.value.id, "menu.deleteList", "trash"), "menu.deleteList.confirm");
		});
	}
});
</script>

<style>

</style>
